import { useQueryClient } from '@tanstack/react-query'
import { toConsignmentItemCreateDraft } from '../models/mapper'
import { ConsignmentItemDetails } from '../models/types'
import { createConsignmentItemDraft } from '../api/createConsignmentItemDraft'
import getConsignmentItemSuccessHandlers from './consignmentItemSuccessHandlers'

function useCreateConsignmentItem(consignmentId: number, houseConsignmentId: number) {
  const queryClient = useQueryClient()
  const { onCreateSuccess } = getConsignmentItemSuccessHandlers(queryClient, consignmentId, houseConsignmentId)

  const saveConsignmentItemDraft = async ({ sequenceNumber } : {
    sequenceNumber: number
  }): Promise<ConsignmentItemDetails> => {
    const created = await createConsignmentItemDraft(toConsignmentItemCreateDraft(
      houseConsignmentId,
      sequenceNumber,
    ))
    await onCreateSuccess(created)
    return created
  }

  return {
    saveConsignmentItemDraft,
  }
}

export default useCreateConsignmentItem
